var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 667.6 274"
    }
  }, _vm.$listeners), [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "endoCert_svg__V"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M-92.3-33.2h850.4V307H-92.3z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__W"
    }
  }, [_c('rect', {
    attrs: {
      "y": "23.4",
      "width": "667.6",
      "height": "227",
      "rx": "10.2",
      "ry": "10.2",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__Y"
    }
  }, [_c('path', {
    attrs: {
      "d": "M39.4 136.8c0 75.2 60.9 136.1 136.1 136.1S311.6 212 311.6 136.8 250.7.7 175.5.7 39.4 61.6 39.4 136.8",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aa"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M-92.3-33.2h850.4V307H-92.3z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__b"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-89.4 270.602 168.477)",
      "fill": "none",
      "d": "M234.3 123.3h72.9v90.2h-72.9z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ac"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M117.5 66.5h129.9v148.4H117.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__e"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-89.4 258.088 159.294)",
      "fill": "none",
      "d": "M221.7 114.2h73v90.2h-73z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ae"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M100 51.8h164.1v178H100z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__af"
    }
  }, [_c('path', {
    attrs: {
      "d": "M182.2 66.5c-4.5 0-9 .7-13.7 1.9-9.4 2.5-17.7 6.5-24.9 12.1-7.2 5.5-13.1 12.2-17.4 20.1-4.4 7.9-7.1 16.7-8.2 26.6-1.1 9.8-.1 20.4 2.9 31.6 3 11.2 7.4 20.8 13.2 28.7 5.8 7.9 12.5 14.2 20.1 18.7 7.6 4.5 15.9 7.3 25 8.4 2.6.3 5.2.5 7.8.5h.3c6.5 0 13-.9 19.7-2.7 5.7-1.5 10.8-4.1 15.5-7.7 4.7-3.6 8.8-7.7 12.4-12.4 3.6-4.7 6.6-9.7 9-15 1.4-3.1 2.5-6.1 3.5-9.1-2.2 4.8-4.9 9.3-8.1 13.5-3.3 4.2-7 8-11.3 11.2-4.2 3.2-8.9 5.6-14 6.9-8.6 2.3-17 3-25.2 2-8.2-.9-15.7-3.5-22.6-7.6-6.9-4.1-13-9.7-18.2-16.9-5.2-7.2-9.2-15.8-11.9-26-2.7-10.1-3.6-19.6-2.6-28.6 1-8.9 3.5-16.9 7.4-24.1 4-7.1 9.2-13.2 15.8-18.2 6.6-5 14.1-8.7 22.6-10.9 5-1.3 10-1.9 14.8-1.7-3.7-.9-7.5-1.4-11.4-1.4h-.4z",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__g"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M100 51.8h164.1v178H100z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__h"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-6.5 182.794 141.118)",
      "fill": "none",
      "d": "M108.7 59h146.7v163.5H108.7z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ah"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M100 51.8h164.1v178H100z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ai"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-6.5 182.794 141.118)",
      "fill": "none",
      "d": "M108.8 59.6h146.6v162.3H108.8z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__k"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-89.4 270.602 168.477)",
      "fill": "none",
      "d": "M234.3 123.3h72.9v90.2h-72.9z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__m"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 236.267 70.485)",
      "fill": "none",
      "d": "M191.1 34h90.2v73h-90.2z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__al"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M104.5 58.5h156.9v157.3H104.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__p"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M204.1 206.9l90.2 1 .8-72.7-90.2-1-.8 72.7z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__r"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 239.128 60.964)",
      "fill": "none",
      "d": "M194 18.4h90.2v85H194z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__an"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ao"
    }
  }, [_c('path', {
    attrs: {
      "d": "M188.2 58.5c-6.3 0-13.3.9-20 2.7-8.2 2.2-15 5.2-21.7 9-6.7 3.8-12.7 8.2-17.9 13.2-5.2 5-9.6 10.5-13.1 16.4-3.6 6-6.3 12.2-8.1 18.8-1.8 6.5-2.8 13.2-2.9 20.1 0 6.9.8 13.7 2.6 20.4 1.8 6.8 4.4 13.1 7.9 18.9 3.5 5.9 7.6 11.2 12.3 15.8 4.8 4.7 10.1 8.7 16.1 12 6 3.4 12.4 5.9 19.3 7.5 6.5 1.6 13.3 2.4 20.5 2.4H184.4c7.6 0 15.5-1.2 23.6-3.4 8.4-2.3 15.8-5.3 22-9.2 6.3-3.9 11.6-8.3 16.1-13.1 4.5-4.9 8.2-10.1 11.1-15.7 1.6-3 3-6 4.2-9.1l-11.6-3.6c-.7 2.1-1.6 4.2-2.5 6.3-1 3-2.1 6-3.5 9.1-2.4 5.3-5.4 10.4-9 15-3.6 4.7-7.8 8.8-12.4 12.4-4.7 3.6-9.9 6.1-15.5 7.7-9.5 2.6-18.8 3.3-27.9 2.3-9-1-17.4-3.8-25-8.4-7.6-4.5-14.3-10.8-20.1-18.7-5.8-7.9-10.2-17.5-13.2-28.7s-4-21.7-2.9-31.6c1.1-9.9 3.8-18.7 8.2-26.6 4.4-7.9 10.2-14.6 17.4-20.1 7.2-5.5 15.6-9.6 24.9-12.1 8.8-2.4 17.3-2.5 25.5-.5 4.6.2 9.1 1.2 13.5 2.8 8.4 3.2 16.9 9.2 25.5 18 .7.7 1.3 1.4 2 2.1l8.7-9.9c-4.3-4-9.2-7.7-14.6-11.1-5.4-3.4-11.3-6-17.6-8-2-.6-4.1-1.2-6.3-1.6-4.5-1-9.1-1.6-13.9-1.8H188z",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__t"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aq"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ar"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__w"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-64.7 254.405 187.022)",
      "fill": "none",
      "d": "M218.1 141.9h73v90.2h-73z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__y"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 227.577 49.172)",
      "fill": "none",
      "d": "M182.5 12.7h90.2v73h-90.2z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__au"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__av"
    }
  }, [_c('path', {
    attrs: {
      "d": "M163.5 52c-7.6 1.7-15.3 4.8-23 9.2-8.1 4.7-15.2 10-21.2 15.9-6.1 6-11.1 12.3-15.2 19.1-4.1 6.8-7.2 13.8-9.3 21.2-2.1 7.4-3.2 14.8-3.3 22.2v1.1c0 7.1.9 14.1 2.7 21 1.9 7.3 4.7 14.3 8.6 21 3.8 6.7 8.4 12.6 13.8 17.9 5.3 5.3 11.2 9.7 17.6 13.3 6.4 3.6 13.2 6.4 20.5 8.2 7.3 1.9 14.8 2.7 22.6 2.5 7.8-.2 15.7-1.4 23.8-3.7 8.1-2.3 16.1-5.7 24.1-10.3 8.3-4.8 15.2-10.1 20.7-16.1 5.5-5.9 10-12.1 13.4-18.5.8-1.4 1.5-2.9 2.1-4.3l-2-1.4c-.2.5-.5 1.1-.8 1.6 0 .1-.1.2-.2.3-.4.7-.7 1.5-1.1 2.2-2.9 5.6-6.6 10.8-11.1 15.7-4.5 4.9-9.9 9.2-16.1 13.1-6.3 3.9-13.6 7-22 9.2-8.1 2.2-15.9 3.3-23.6 3.4-7.6 0-14.9-.7-21.8-2.4s-13.3-4.2-19.3-7.5-11.3-7.4-16.1-12c-4.8-4.7-8.9-10-12.3-15.8-3.5-5.9-6.1-12.2-7.9-18.9-1.8-6.8-2.7-13.6-2.6-20.4 0-6.8 1-13.5 2.9-20.1 1.8-6.5 4.5-12.8 8.1-18.8 3.6-6 8-11.5 13.1-16.4 5.2-5 11.1-9.4 17.9-13.2 5.3-3 10.6-5.4 16.6-7.4.7-.2 1.4-.5 2.1-.7h.3c.3 0 .7-.2 1-.3.6-.2 1.2-.3 1.8-.5 6-1.6 12.2-2.5 18-2.7h5c.8 0 1.5 0 2.3.1h.7c.6 0 1.1 0 1.7.1.4 0 .9 0 1.3.1.4 0 .9 0 1.3.2.4 0 .9.1 1.3.2h.6c1.6.2 3.2.5 4.7.9.9.2 1.7.4 2.6.6.3 0 .5.1.8.2.3 0 .6.2.9.2.7.2 1.3.4 2 .6l2.7.9c.3 0 .5.2.8.3.6.2 1.3.5 1.9.7.3.1.6.2.8.3.6.3 1.3.5 1.9.8.2.1.5.2.7.3.8.4 1.7.8 2.5 1.1l2.8-5.6c-5.7-3-11.9-5.6-18.6-7.6-6.7-2-13.7-3.2-21-3.4h-3c-6.3 0-12.8.7-19.4 2.2",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__A"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ax"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__ay"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__D"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M155.4 121.5l3 19 56.6-24.3-3.4-17.4-56.2 22.7z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aB"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133 75.7h111.3v120.7H133z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aC"
    }
  }, [_c('path', {
    attrs: {
      "d": "M190.9 93.6c.3 0 .5.2.8.3-.3-.1-.5-.2-.8-.3M160 114.4c.5-3.6 1.4-6.8 2.8-9.7 1.4-2.9 3.3-5.4 5.6-7.4 2.3-2.1 4.9-3.5 7.7-4.2 2.6-.7 5.1-1 7.7-.8.8 0 1.7.1 2.5.3 1.5.2 2.9.6 4.4 1.1 1.7 1.3 3.3 2.8 4.8 4.5 2.7 3.1 4.8 6.7 6.3 10.8L160 124c0-.5-.5-6.1 0-9.4m-9.9-10.7c1.3-3.4 3.2-6.4 5.6-8.9 2.4-2.5 5.2-4.4 8.3-5.5 1.9-.7 3.9-1.2 5.8-1.4-2.9 1.5-5.6 3.3-8 5.4-5.1 4.3-9 9.5-11.8 15.5-.8 1.8-1.6 3.7-2.2 5.7.2-3.9 1-7.5 2.2-10.7m35-28.3c-5.7 0-11.5 1.1-17.4 3.2-7.8 2.8-14.4 6.9-19.7 12.3-5.3 5.4-9.2 11.6-11.8 18.7-.1.4-.2.7-.4 1.1-1.1 3.7-1.9 7.6-2.3 11.7-.3 2.3-.4 4.7-.4 7.1v.5c0 6.7 1 13.7 3 21 2.2 8.4 5.4 15.7 9.3 22.1 1.2 1.6 2.5 3.2 3.8 4.7 5 5.4 10.8 9.7 17.2 12.8 6.4 3.1 13.3 4.9 20.6 5.4 1.2 0 2.3.1 3.5.1h.5c5.9 0 11.8-1.1 17.7-3.2 5.5-2 10.5-5 15.1-9.1s8.5-8.8 11.6-14.1c3.2-5.3 5.6-11 7.2-17.2 1.2-4.6 1.8-9.2 1.8-13.8v-.3c0-1.5 0-3-.2-4.4l-7-.6v5.4c0 .4 0 .9-.2 1.3v.3c0 .2 0 .4-.1.7-.3 1.9-.9 3.9-1.7 5.9 0 .1 0 .2-.1.3-.1.3-.4 1-.5 1.1v.2c-.3.6-.6 1.2-.9 1.9 0 .1-.1.3-.2.4-.1.2-.2.4-.4.6-.1.2-.2.4-.3.5-.1.2-.2.4-.4.6-.1.2-.2.4-.4.6-.1.2-.2.4-.3.5-.1.2-.3.4-.4.6-.1.2-.2.3-.3.5-.2.3-.4.5-.5.8 0 .1-.2.2-.3.3-.3.4-.6.7-.9 1.1-2.5 3.1-5.5 5.8-8.9 8.2-3.4 2.4-7.2 4.2-11.4 5.3-4.9 1.3-9.8 1.4-14.6.1-3-.8-5.8-1.9-8.6-3.5-1.6-1-3.2-2.1-4.7-3.3-4.1-3.3-7.7-7.6-10.9-12.9-3.2-5.3-5.7-11.2-7.5-17.9l.7-.2 70.8-19c-1-3.7-2.4-7.2-4.3-10.5-2.1-4.5-4.8-8.5-8.1-12.2-4.3-4.7-9.3-8.5-15-11.3-5.7-2.8-11.9-4.3-18.5-4.8h-3.1z",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__F"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133 75.7h111.3v120.7H133z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aE"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133 75.7h111.3v120.7H133z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aF"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133 75.7h111.3v120.7H133z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__I"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M160.9 123.4l2.9 12.8 51.5-17.3-3.4-17.5-51 22z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aI"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M127.5 66.2h133.4v139.5H127.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aJ"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133.7 101.1h123v103.4h-123z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aK"
    }
  }, [_c('path', {
    attrs: {
      "d": "M149.9 145.1c2 7.5 5 14 8.9 19.3 3.9 5.3 8.4 9.5 13.6 12.6 5.1 3.1 10.8 4.9 16.9 5.6 6.1.7 12.4.2 18.8-1.5 3.8-1 7.3-2.7 10.5-5.2 3.2-2.4 6-5.2 8.4-8.3 2.4-3.1 4.5-6.5 6.1-10.1 1.6-3.6 2.8-7.1 3.6-10.5l5.5 1.7c.7-3.3 1.1-6.6 1.1-10l-6.1-1c0 3.3-.8 6.7-2.2 10.2-.1.3-.3.7-.4 1-1.2 3-14.4 31.6-47.6 24.2-35.7-7.9-38.6-47.5-38.7-50.6-1 7.4-.3 15.2 1.7 22.7",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__K"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-76.8 195.25 152.801)",
      "fill": "none",
      "d": "M154.6 99.1h81.1v107.3h-81.1z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aM"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M133.7 101.1h123v103.4h-123z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aN"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-76.8 195.25 152.801)",
      "fill": "none",
      "d": "M154.6 99.1h81.1v107.3h-81.1z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__N"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M161.1 125l2.2 9.4 47.3-13.3-3.1-8.8-46.4 12.7z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aQ"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M127.5 66.2h133.4v139.5H127.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aR"
    }
  }, [_c('path', {
    attrs: {
      "d": "M180.1 84c-7.1 1.9-13.1 5-18.2 9.3-5.1 4.3-9 9.5-11.8 15.5-2.8 6-4.4 12.7-4.8 20.1 0 1.3-.1 2.5-.1 3.8 0 6.2.9 12.6 2.6 19.2 1.8 6.6 4.7 12.6 8.7 17.7 4 5.2 8.8 9.3 14.2 12.5 5.4 3.2 11.3 5.3 17.7 6.3 6.4 1 12.8.7 19.3-1.1 4.9-1.3 9.6-3.6 13.9-6.8 4.3-3.2 8.1-7.1 11.3-11.5 3.2-4.4 5.7-9.3 7.6-14.6 1-2.8 1.5-5 1.7-5.8v-.3c.7-3.3 1.1-6.7 1.1-10l-6.1-1c0 3.3-.8 6.7-2.2 10.2-.1.3-.3.7-.4 1-.6 1.5-.7 1.7-.1.3-1.3 3-3.1 5.8-5.3 8.5-2.5 3.1-5.5 5.8-8.9 8.2-3.4 2.4-7.2 4.2-11.4 5.3-4.9 1.3-9.8 1.4-14.6.1-4.8-1.2-9.2-3.5-13.3-6.8-4.1-3.3-7.7-7.6-10.9-12.9-3.2-5.3-5.7-11.2-7.5-17.9 0 0-1.1-3.6-2.1-8.1-.7-3.8-.8-7.6-.4-11.1.5-3.6 1.4-6.8 2.8-9.7 1.4-2.9 3.3-5.4 5.6-7.4 2.3-2.1 4.9-3.5 7.7-4.2 3.4-.9 6.9-1.1 10.2-.6 3.4.6 6.5 1.7 9.4 3.5 2.9 1.8 5.4 4.1 7.5 7 2.1 2.9 3.7 6.2 4.7 10l-46.8 12.4 2 8.1 70.8-19c-1.5-5.5-3.9-10.6-7.4-15.1-3.4-4.5-7.6-8.2-12.3-11-4.8-2.8-10.1-4.7-16-5.6-2-.3-4-.4-6.1-.4-4 0-8 .6-12.2 1.7",
      "fill": "none"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__P"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M127.5 66.2h133.4v139.5H127.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__Q"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-9.6 194.284 135.641)",
      "fill": "none",
      "d": "M136.5 74.5h115v122.6h-115z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aT"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M127.5 66.2h133.4v139.5H127.5z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aU"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-9.6 194.234 136.237)",
      "fill": "none",
      "d": "M136.9 74.9h114.6V197H136.9z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__T"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M160.4 124.1l3.7 13.7 56.7-24.3-3.5-17.4-56.9 28z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aX"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M147.3 82.6h96v100.6h-96z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "endoCert_svg__aY"
    }
  }, [_c('path', {
    attrs: {
      "d": "M182.3 83.9c-6.4 1.6-12.1 4.8-17 8.5s-8.8 8.2-11.8 13.5c-3 5.3-4.8 11.2-5.5 17.9-.7 6.6 0 13.7 1.9 21.2 2 7.5 5 14 8.9 19.3 3.9 5.3 8.4 9.5 13.6 12.6 5.1 3.1 10.8 4.9 16.9 5.6 6.1.7 12.4.2 18.8-1.5 1.9-.5 3.8-1.2 5.5-2.1 1.7-.9 3.4-1.9 5-3.1 3.2-2.4 6-5.2 8.4-8.3 2.4-3.1 4.5-6.5 6.1-10.1 1.6-3.6 2.8-7.1 3.6-10.5l5.5 1.7v-.4c.1-.5.2-1.1.3-1.6 0-.3.1-.7.2-1 0-.4.1-.8.2-1.2 0-.5.1-.9.2-1.4v-.8c0-.6 0-1.3.1-1.9v-.5-1.1l-6.1-1c0 3.3-.8 6.7-2.2 10.2-1.4 3.5-3.3 6.8-5.8 9.9-2.5 3.1-5.5 5.8-8.9 8.2-3.4 2.4-7.2 4.2-11.4 5.3-4.9 1.3-9.8 1.4-14.6.1-4.8-1.2-9.2-3.5-13.3-6.8-4.1-3.3-7.7-7.6-10.9-12.9-3.2-5.3-5.7-11.2-7.5-17.9 0 0-1.1-3.6-2.1-8.1-.7-3.8-.8-7.6-.4-11.1.5-3.6 1.4-6.8 2.8-9.7 1.4-2.9 3.3-5.4 5.6-7.4 2.3-2.1 4.9-3.5 7.7-4.2 3.5-.9 6.9-1.1 10.2-.6 3.4.5 6.5 1.7 9.4 3.5 2.9 1.8 5.4 4.1 7.5 7 2.1 2.9 3.7 6.2 4.7 10l-46.8 12.4 2 8.1 70.8-19c-1.5-5.5-3.9-10.6-7.4-15.1-3.4-4.5-7.6-8.2-12.3-11-2.1-1.3-4.4-2.3-6.7-3.2-4.2-1.5-9.2-2.6-14.8-2.6s-6.8.4-10.5 1.3",
      "fill": "none"
    }
  })]), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__X",
      "data-name": "Dégradé sans nom",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 1176.1 1176.1 0 -360737.2 108052.2)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#004f93"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#005f9e"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#0279b0"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#038fbf"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#167cb9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#06599c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#004a90"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__Z",
      "data-name": "Dégradé sans nom 2",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(272.3 0 0 -272.3 25161.5 83720.2)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#06599c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#167cb9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#038fbf"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#0279b0"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#005f9e"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#004f93"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#004a90"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#004a90"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__c",
      "data-name": "Dégradé sans nom 3",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(-73 0 0 -60.6 -6424.1 18786.4)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#313130"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7e7e7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#c3c3c3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__f",
      "data-name": "Dégradé sans nom 6",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(-51.9 0 0 -43.1 -4508 13394.4)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#313130"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7e7e7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#c3c3c3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__i",
      "data-name": "Dégradé sans nom 5",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(18431.7 -60784.7) scale(198.5)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fefefe"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#ebebeb"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c2c2c1"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#9d9d9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#9d9d9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#9d9d9c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__aj",
      "data-name": "Dégradé sans nom 4",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(18429.4 -60776.6) scale(198.4)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#0067b2"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#0076bd"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#1e89c9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#67b9e8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#6dbbe8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#bbdff4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#ecf6fc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__l",
      "data-name": "Dégradé sans nom 7",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(-3.57304 42.55025 -35.37534 -4.16747 10786.2 5367.2)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#2a2a28"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#4d4d4b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#868685"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#d3d3d3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__n",
      "data-name": "Dégradé sans nom 8",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 -89.5 74.4 0 -22609.1 -8135.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#2a2a29"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#343433"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#474746"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#7a7a79"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#cacaca"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__q",
      "data-name": "Dégradé sans nom 11",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "rotate(90.4 3260.806 7079.702) scale(39.6 33)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#313130"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#7e7e7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#c3c3c3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__s",
      "data-name": "Dégradé sans nom 12",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 -85 60.7 0 -18382.3 -7738.5)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#484847"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#959595"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#cecece"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#f1f1f1"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__u",
      "data-name": "Dégradé sans nom 10",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(157 0 0 157 14593 -48067.3)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#b9b8b8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#acabab"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#9d9d9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#9d9d9c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__as",
      "data-name": "Dégradé sans nom 9",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(157 0 0 157 14593 -48067.3)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#008fd2"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#71c0e6"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__x",
      "data-name": "Dégradé sans nom 15",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(-47.9 0 0 -39.8 -4125.3 12401.6)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#313130"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7e7e7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#c3c3c3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__z",
      "data-name": "Dégradé sans nom 16",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 -73 60.7 0 -18399.3 -6648.7)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#313130"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#7e7e7d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#c3c3c3"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__B",
      "data-name": "Dégradé sans nom 14",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(15769.6 -52025.5) scale(169.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#706f6f"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#706f6f"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#706f6f"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#9d9d9c"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#9d9d9c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__az",
      "data-name": "Dégradé sans nom 13",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(15762.3 -52001.1) scale(169.8)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#0067b2"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#0067b2"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#0067b2"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#67a4d1"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__E",
      "data-name": "Dégradé sans nom 19",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(57.68308 -25.08132 15.1229 94.0721 844 -31056)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#363634"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#6a6a69"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#989897"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#bdbdbc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#dadad9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#eee"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fafafa"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__G",
      "data-name": "Dégradé sans nom 18",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(11953.5 -39271.8) scale(128.4)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#575756"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#646463"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#7d7d7c"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#8e8e8d"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#999998"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#9d9d9c"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__aG",
      "data-name": "Dégradé sans nom 17",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(11961.7 -39299.4) scale(128.5)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#f1f6fa"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#b9d5e9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#87b7db"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#5e9fce"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#3c8ac4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#217bbc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#0e6fb6"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#0369b3"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#0067b2"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__J",
      "data-name": "Dégradé sans nom 27",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(52.45584 -22.80845 13.77807 85.60618 787.5 -28263.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#464644"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".1",
      "stop-color": "#717170"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#979796"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#b7b7b7"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#d1d1d1"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#e5e5e5"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#f4f4f4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#fcfcfc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__L",
      "data-name": "Dégradé sans nom 21",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 189 -189 0 58225.2 17463.8)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#706f6f"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#b5b5b5"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__aO",
      "data-name": "Dégradé sans nom 20",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(0 189 -189 0 58226.9 17464.3)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#005ca9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#005ca9"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#005ca9"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__O",
      "data-name": "Dégradé sans nom 24",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(50 0 0 50 4777.2 -15234.1)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#31312f"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#676765"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#959594"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#bbb"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#d9d9d8"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#eeeeed"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#fafafa"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__R",
      "data-name": "Dégradé sans nom 23",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "rotate(180 -6280.15 21392.9) scale(138.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#fbfbfb"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#f1f0f0"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#dfdfdf"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#c6c6c6"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#a6a5a5"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7f7e7e"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#706f6f"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__aV",
      "data-name": "Dégradé sans nom 22",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(-139 0 0 -139 -12562.7 42794.5)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#005ca9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#005ca9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#008fd2"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#0490d2"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#1196d5"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#27a0d9"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#46aede"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#6ebfe5"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".9",
      "stop-color": "#9ed4ee"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#d7edf7"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__U",
      "data-name": "Dégradé sans nom 26",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "matrix(59.15037 -25.71931 15.4885 96.42114 866.7 -31840.1)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#1d1d1b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#363634"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#7c7c7b"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".5",
      "stop-color": "#b4b4b4"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#dddddc"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".7",
      "stop-color": "#f5f5f5"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".8",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#fff"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "endoCert_svg__aZ",
      "data-name": "Dégradé sans nom 25",
      "x1": "-92.3",
      "y1": "307",
      "x2": "-91.3",
      "y2": "307",
      "gradientTransform": "translate(15283.1 -50478.5) scale(164.9)",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#d2e4f1"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#63a2d0"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#0067b2"
    }
  })], 1), _c('mask', {
    attrs: {
      "id": "endoCert_svg__ab",
      "x": "117.5",
      "y": "66.5",
      "width": "199.6",
      "height": "148.4",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__a)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__b)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-89.4 270.602 168.477)",
      "fill": "url(#endoCert_svg__c)",
      "d": "M233.3 122.5h74.9v91.8h-74.9z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__ad",
      "x": "79.9",
      "y": "33.2",
      "width": "224.6",
      "height": "215.1",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__d)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__e)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-89.4 258.088 159.294)",
      "fill": "url(#endoCert_svg__f)",
      "d": "M220.7 113.4h75v91.8h-75z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__ag",
      "x": "79.6",
      "y": "32.6",
      "width": "204.9",
      "height": "216.4",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 51.8h164.1v178H100z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__g)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__h)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-6.5 182.794 141.118)",
      "fill": "url(#endoCert_svg__i)",
      "d": "M90.2 42.4h183.7v196.7H90.2z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__ak",
      "x": "104.5",
      "y": "-30.9",
      "width": "232.5",
      "height": "246.9",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__j)"
    }
  }, [_c('g', {
    staticStyle: {
      "isolation": "isolate"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__k)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__l)",
      "d": "M226.2 120.8l-7.1 83.8 96.2 11.4 7.1-83.8-96.2-11.4z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__m)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 236.267 70.485)",
      "fill": "url(#endoCert_svg__n)",
      "d": "M160.7-3.5h150.9v148H160.7z"
    }
  })])])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__am",
      "x": "104.5",
      "y": "-47.8",
      "width": "243.1",
      "height": "263.6",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__o)"
    }
  }, [_c('g', {
    staticStyle: {
      "isolation": "isolate"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__p)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__q)",
      "d": "M204.1 133.8l-.5 74.1 91.5.5.4-74.2-91.4-.4z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__r)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 239.128 60.964)",
      "fill": "url(#endoCert_svg__s)",
      "d": "M158.6-19.1h160.9V141H158.6z"
    }
  })])])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__ap",
      "x": "104.5",
      "y": "58.3",
      "width": "157",
      "height": "157.6",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__t)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__u)",
      "d": "M104.5 58.3h157v157.6h-157z"
    }
  })])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__at",
      "x": "91.5",
      "y": "-52.3",
      "width": "259.9",
      "height": "335.1",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__v)"
    }
  }, [_c('g', {
    staticStyle: {
      "isolation": "isolate"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__w)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-64.7 254.405 187.022)",
      "fill": "url(#endoCert_svg__x)",
      "d": "M183.2 113.7h142.7v146.6H183.2z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__y)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-61.8 227.577 49.172)",
      "fill": "url(#endoCert_svg__z)",
      "d": "M152.1-24.8H303v148H152.1z"
    }
  })])])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aw",
      "x": "91.4",
      "y": "49.6",
      "width": "169.9",
      "height": "175.1",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__A)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__B)",
      "d": "M91.4 49.6h169.9v175.1H91.4z"
    }
  })])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aA",
      "x": "133",
      "y": "74.5",
      "width": "111.3",
      "height": "121.9",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__C)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__D)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__E)",
      "d": "M159.3 164.7l62-26.9-10.2-63.3-62 27 10.2 63.2z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aD",
      "x": "132.4",
      "y": "75.3",
      "width": "112.2",
      "height": "121.4",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M133 75.7h111.3v120.7H133z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__F)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__G)",
      "d": "M132.4 75.3h112.2v121.4H132.4z"
    }
  })])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aH",
      "x": "104.5",
      "y": "44.3",
      "width": "179.3",
      "height": "187.6",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__H)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__I)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__J)",
      "d": "M164.5 158.3l56-24.4-8.7-54.6-56.1 24.4 8.8 54.6z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aL",
      "x": "110.7",
      "y": "73.8",
      "width": "168.9",
      "height": "158",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M133.7 101.1h123v103.4h-123z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__K)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-76.8 195.25 152.801)",
      "fill": "url(#endoCert_svg__L)",
      "d": "M130.8 81.1h128.7v143.3H130.8z"
    }
  })])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aP",
      "x": "104.5",
      "y": "44.3",
      "width": "179.3",
      "height": "183.4",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__M)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__N)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-16.3 185.805 123.165)",
      "fill": "url(#endoCert_svg__O)",
      "d": "M159 105.8h53.7v35H159z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aS",
      "x": "104",
      "y": "43.7",
      "width": "179.9",
      "height": "184.1",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.5 66.2h133.4v139.5H127.5z"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__P)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__Q)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-9.6 194.284 135.641)",
      "fill": "url(#endoCert_svg__R)",
      "d": "M116.3 55.5h155.3V216H116.3z"
    }
  })])])]), _c('mask', {
    attrs: {
      "id": "endoCert_svg__aW",
      "x": "147.3",
      "y": "71.5",
      "width": "96",
      "height": "111.6",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#endoCert_svg__S)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__T)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__U)",
      "d": "M164.4 162.3l62.6-27.2-10.2-63.6-62.6 27.3 10.2 63.5z"
    }
  })])])]), _c('filter', {
    attrs: {
      "id": "endoCert_svg__a",
      "x": "117.5",
      "y": "66.5",
      "width": "199.6",
      "height": "148.4",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__d",
      "x": "79.9",
      "y": "33.2",
      "width": "224.6",
      "height": "215.1",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__j",
      "x": "104.5",
      "y": "-30.9",
      "width": "232.5",
      "height": "246.9",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__o",
      "x": "104.5",
      "y": "-47.8",
      "width": "243.1",
      "height": "263.6",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__v",
      "x": "91.5",
      "y": "-52.3",
      "width": "259.9",
      "height": "335.1",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__C",
      "x": "133",
      "y": "74.5",
      "width": "111.3",
      "height": "121.9",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__H",
      "x": "104.5",
      "y": "44.3",
      "width": "179.3",
      "height": "187.6",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__M",
      "x": "104.5",
      "y": "44.3",
      "width": "179.3",
      "height": "183.4",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "endoCert_svg__S",
      "x": "147.3",
      "y": "71.5",
      "width": "96",
      "height": "111.6",
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-color": "#fff",
      "result": "bg"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "bg"
    }
  })], 1)], 1), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__V)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__W)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-85.1 333.813 136.9)",
      "fill": "url(#endoCert_svg__X)",
      "d": "M192.2-205.3h283.2v684.6H192.2z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__Y)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-30 175.535 136.835)",
      "fill": "url(#endoCert_svg__Z)",
      "d": "M-10.4-49.1h371.9v371.9H-10.4z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aa)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M298.5 136.8c0 67.9-55.1 123-123 123s-123-55.1-123-123 55-123 123-123 123 55.1 123 123M403.9 134.8c0 .2-.4.6-.6.6h-18c0 2.7.5 4.2 1.5 5.5 1.4 1.8 3.8 2.4 7.2 2.4s4.8-.5 7.1-1.2h.4c.2 0 .3 0 .4.4l.5 1.9c.1.4-.1.6-.5.7-2 .8-5.2 1.4-8.4 1.4-9.6 0-12.4-4.5-12.4-13.5s1.7-13.5 11.4-13.5 8.1 1.6 9.7 4.4c1.3 2.2 1.6 5.2 1.6 8.6v2.4zm-4.7-8.2c-.8-3.1-2.7-4.2-6.7-4.2s-5.8 1-6.7 4.2c-.5 1.8-.5 3.7-.6 5.5h14.6c0-1.9-.1-3.7-.6-5.5M431.5 145.7h-2.4c-.4 0-.7-.3-.7-.7v-18.1c0-3.2-1.2-4.4-4.7-4.4s-8.2 1.1-9.2 1.4V145c0 .4-.2.7-.7.7h-2.4c-.4 0-.7-.3-.7-.7v-20.3c0-2 0-2.8 2.5-3.7 2.5-.9 7.4-1.6 10.6-1.6 5.8 0 8.4 1.8 8.4 7.1v18.6c0 .4-.3.7-.7.7M457.7 145.5c-1.6.4-3.6.8-7.2.8-9.5 0-11.7-4.3-11.7-13.5s2.6-13.5 11.4-13.5 5.8.5 7.5 1l-.5-2.8v-7.3c0-.4.2-.5.6-.6l2.6-.7c.5-.1.6.3.6.6v32c0 1.8 0 3.2-3.4 4m-.4-22.2c-.6-.2-3.5-.9-6.6-.9-5.4 0-7.8 1.7-7.8 10.4s2.8 10.4 7.8 10.4 6-.7 6.6-.9v-19zM479.1 146.4c-10.2 0-11.5-6.1-11.5-13.5s1.2-13.5 11.5-13.5 11.5 6.1 11.5 13.5-1.2 13.5-11.5 13.5m0-23.9c-7.1 0-7.4 4.2-7.4 10.4s.3 10.3 7.4 10.3 7.4-4.2 7.4-10.3-.3-10.4-7.4-10.4M523.8 143.5c0 .2-.1.6-.8.8-2.2.7-5.8 1.8-11.2 1.8-12.1 0-15.4-6.6-15.4-18.5s3.3-18.5 15.4-18.5 9.1 1.1 11.2 1.8c.6.2.8.5.8.8v.3l-.4 1.9c0 .5-.3.6-.6.6h-.5c-2.4-.6-6-1.5-10.1-1.5-9.2 0-11.4 4.5-11.4 14.7s2.2 14.8 11.4 14.8 7.7-.8 10.1-1.5h.5c.3 0 .5.1.6.6l.4 1.8v.3M551.5 134.8c0 .2-.4.6-.6.6h-18c0 2.7.5 4.2 1.5 5.5 1.4 1.8 3.8 2.4 7.2 2.4s4.8-.5 7.1-1.2h.4c.2 0 .3 0 .4.4l.5 1.9c.1.4-.1.6-.5.7-2 .8-5.2 1.4-8.4 1.4-9.6 0-12.4-4.5-12.4-13.5s1.7-13.5 11.4-13.5 8.1 1.6 9.7 4.4c1.3 2.2 1.6 5.2 1.6 8.6v2.4zm-4.7-8.2c-.8-3.1-2.7-4.2-6.7-4.2s-5.8 1-6.7 4.2c-.5 1.8-.5 3.7-.6 5.5h14.6c0-1.9-.1-3.7-.6-5.5M559 145.7c-.4 0-.7-.3-.7-.7v-20.4c0-2.2.4-2.8 2.1-3.6 2.2-1 6.6-1.6 8.9-1.6h1.2c.2 0 .7 0 .7.7v2.1c0 .3 0 .6-.4.6-3.2 0-5.9.2-8.6.9V145c0 .4-.2.7-.7.7H559zM590.4 144.8c0 .3-.1.5-.4.6-.9.3-3.2.9-6 .9-4.8 0-7.2-2.1-7.2-6.8v-26.9c0-.4.2-.5.6-.6l2.6-.7c.3 0 .6.2.6.6v8h8.2c.4 0 .7.3.7.7v1.7c0 .4-.3.7-.7.7h-8.2v16.8c0 2.7 1.5 3.3 4 3.3s3.2-.3 4.5-.6c.3 0 .6 0 .7.4l.4 1.8zM358.6 95.3h253.9v1H358.6zM518.5 79.9h-.8c-.1 0-.2-.1-.2-.2v-4.9H511v4.9c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2V69.1c0-.1 0-.2.2-.2h.9c.1-.2.2 0 .2 0v4.7h6.5V69c0-.1 0-.2.2-.2h.9c.1-.2.2 0 .2 0v10.7c0 .1-.1.2-.2.2M525.9 80.1c-3.5 0-4.4-1.6-4.4-4.1v-6.9c0-.1 0-.2.2-.2h.9c.1-.2.2 0 .2 0v7.2c0 1.8.5 2.9 3.1 2.9s3.1-.7 3.1-2.6v-7.3c0-.1 0-.2.2-.2h.9c.1-.2.2 0 .2 0v7c0 2.2-.4 4.2-4.4 4.2m-.6-12.9s0 .1-.1.1h-1.5s-.1 0-.1-.1v-.8s0-.1.1-.1h1.5s.1 0 .1.1v.8zm2.9 0s0 .1-.1.1h-1.5s-.1 0-.1-.1v-.8s0-.1.1-.1h1.5s.1 0 .1.1v.8zM539.7 70.1h-5.4v4.3h4.9c.1 0 .2.1.2.2v.7c0 .1-.1.2-.2.2h-4.9v4.1c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2V69.1c0-.1.1-.2.2-.2h6.4c.1 0 .2.1.2.2v.7c0 .1-.1.2-.2.2",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "d": "M547.5 70h-3.6v9.6c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2V70h-3.6c-.1 0-.2-.1-.2-.2v-.6c0-.1.1-.2.2-.2h8.5c.1 0 .2.1.2.2v.6c0 .1-.1.2-.2.2M556.3 79.9h-6.7c-.1 0-.2-.1-.2-.2V69.2c0-.1.1-.2.2-.2h6.7c.1 0 .2.1.2.2v.6c0 .1-.1.2-.2.2h-5.7v3.6h5.5c.1 0 .2.1.2.2v.7c0 .1 0 .2-.2.2h-5.5v4.1h5.7c.1 0 .2.1.2.2v.6c0 .1-.1.2-.2.2M499.1 69.1l-6.9 6.9-3.2-3.1-1.9 1.9 5 5.1h.1L501 71l-1.9-1.9zM444 79.8s0 .1-.1.1h-1.5l-4.5-4.9h-.6v4.8c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2V69.3c0-.1.1-.2.2-.2h.8c.1 0 .2.1.2.2v4.6h.6l4.3-4.7h1.3s.1.1.1.2l-4.7 5.1L444 80M455.1 80h-1.7c-.1 0-.3 0-.4-.2l-5.5-9.7h-.5v9.7c0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2V69.3c0-.1.1-.2.2-.2h2.2c.2 0 .3 0 .4.2l5.5 9.8h.1v-9.8c0-.1 0-.2.2-.2h.9c.2 0 .2 0 .2.2v10.6c0 .1-.1.2-.2.2M459.3 80h-.8c-.1 0-.2-.1-.2-.2V69.2c0-.1 0-.2.2-.2h.9c.1-.2.2 0 .2 0v10.8c0 .1-.1.2-.2.2M469.5 80h-6.7c-.1 0-.2-.1-.2-.2V69.3c0-.1.1-.2.2-.2h6.7c.1 0 .2.1.2.2v.6c0 .1-.1.2-.2.2h-5.7v3.6h5.5c.1 0 .2.1.2.2v.7c0 .1 0 .2-.2.2h-5.5v4.1h5.7c.1 0 .2.1.2.2v.6c0 .1-.1.2-.2.2M425.4 69.2l-6.9 6.9-3.2-3.1-1.9 1.9 5 5.1h.1l8.9-8.9-2-1.9zM425.4 179.1h-12.1c-.2 0-.3-.2-.3-.3v-1.6c0-.4.1-.4.2-.6l8.5-11.2h-8.5c-.2 0-.3-.1-.3-.3v-1.7c0-.2.2-.3.3-.3h11.9c.2 0 .3.2.3.3v1.7c0 .2 0 .3-.2.5l-8.6 11.2h8.7c.2 0 .3.1.3.3v1.7c0 .2-.2.3-.3.3M438.8 174.3c0 .2-.1.5-.5.5H431c0 1 .3 1.5.9 2 .6.5 1.4.7 2.6.7s2.3-.3 3-.5h.2c.1 0 .3 0 .3.3l.3 1.1v.1c0 .2-.1.3-.3.3-.7.3-2.2.7-3.9.7-4.3 0-5.9-1.7-5.9-5.9s1.1-6 5.4-6 3.5.6 4.3 1.6c.7 1 1 2.4 1 4.2v1zm-3.1-3.3c-.3-1.2-.9-1.6-2.2-1.6s-2.1.4-2.3 1.5c-.2.6-.2 1.2-.2 1.9h4.9c0-.7 0-1.3-.2-1.9M442.2 169.4c0-.8.5-1.1 1.5-1.4 1-.3 2.5-.5 3.7-.5h.8s.2.1.2.3v1.4c0 .2 0 .4-.3.4-1.3 0-2.5.1-3.1.3v8.8c0 .2-.1.3-.3.3h-2.3c-.2 0-.3-.1-.3-.3v-9.4zM457.9 178.9c-.4.1-1.3.4-2.7.4-2.5 0-3.7-1-3.7-3.4v-11.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5h3.1c.2 0 .3.1.3.3v1.5c0 .2-.1.3-.3.3h-3.1v6c0 1 .4 1.3 1.5 1.3s1.3-.1 1.7-.2c.2 0 .3 0 .3.2l.3 1.2c0 .2 0 .4-.2.5M464 179.1h-2.2c-.2 0-.3-.1-.3-.3v-10.6c0-.2.2-.3.3-.3h2.2c.2 0 .3.1.3.3v10.6c0 .2-.1.3-.3.3m-.2-12.9H462c-.3 0-.5-.2-.5-.5v-2.5c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v2.5c0 .3-.2.5-.5.5M478.9 179.1h-2.2c-.2 0-.3-.1-.3-.3v-9h-4v9c0 .2-.1.3-.3.3h-2.2c-.2 0-.3-.1-.3-.3v-9h-1.7c-.2 0-.3-.1-.3-.3V168c0-.2.1-.3.3-.3h1.7v-.9c0-3.2 1.6-4 4.6-4s3.2.3 3.7.5c.2 0 .3.2.3.3l-.2 1.3c0 .2 0 .3-.3.3h-.2c-.6 0-1.5-.3-2.9-.3s-2.2.3-2.2 2v.8h6.5c.2 0 .4.2.4.4v10.7c0 .2-.1.3-.3.3M492.1 178.8c0 .2-.1.3-.3.3h-8.6c-.2 0-.3-.1-.3-.3v-1.3c0-.2 0-.3.2-.5l5.6-7.3h-5.5c-.2 0-.3-.1-.3-.3V168c0-.2.2-.3.3-.3h8.6c.2 0 .3.1.3.3v1.3c0 .2 0 .3-.2.5l-5.6 7.2h5.5c.2 0 .3.1.3.3v1.4zM498.2 179.1H496c-.2 0-.3-.1-.3-.3v-10.6c0-.2.2-.3.3-.3h2.2c.2 0 .3.1.3.3v10.6c0 .2-.1.3-.3.3m-.2-12.9h-1.8c-.3 0-.5-.2-.5-.5v-2.5c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v2.5c0 .3-.2.5-.5.5M512.8 174.3c0 .2-.1.5-.5.5H505c0 1 .3 1.5.9 2 .6.5 1.4.7 2.6.7s2.3-.3 3-.5h.2c.1 0 .3 0 .3.3l.3 1.1v.1c0 .2-.1.3-.3.3-.7.3-2.2.7-3.9.7-4.3 0-5.9-1.7-5.9-5.9s1.1-6 5.4-6 3.5.6 4.3 1.6c.7 1 1 2.4 1 4.2v1zm-3.1-3.3c-.3-1.2-.9-1.6-2.2-1.6s-2.1.4-2.3 1.5c-.2.6-.2 1.2-.2 1.9h4.9c0-.7 0-1.3-.2-1.9M516.1 169.4c0-.8.5-1.1 1.5-1.4 1-.3 2.5-.5 3.7-.5h.8s.2.1.2.3v1.4c0 .2 0 .4-.3.4-1.3 0-2.5.1-3.1.3v8.8c0 .2-.1.3-.3.3h-2.3c-.2 0-.3-.1-.3-.3v-9.4zM531.9 178.9c-.4.1-1.3.4-2.7.4-2.5 0-3.7-1-3.7-3.4v-11.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5h3.1c.2 0 .3.1.3.3v1.5c0 .2-.1.3-.3.3h-3.1v6c0 1 .4 1.3 1.5 1.3s1.3-.1 1.7-.2c.2 0 .3 0 .3.2l.3 1.2c0 .2 0 .4-.2.5M545.1 174.3c0 .2-.1.5-.5.5h-7.3c0 1 .3 1.5.9 2 .6.5 1.4.7 2.6.7s2.3-.3 3-.5h.2c.1 0 .3 0 .3.3l.3 1.1v.1c0 .2-.1.3-.3.3-.7.3-2.2.7-3.9.7-4.3 0-5.9-1.7-5.9-5.9s1.1-6 5.4-6 3.5.6 4.3 1.6c.7 1 1 2.4 1 4.2v1zM542 171c-.3-1.2-.9-1.6-2.2-1.6s-2.1.4-2.3 1.5c-.2.6-.2 1.2-.2 1.9h4.9c0-.7 0-1.3-.2-1.9M552.2 179.4c-1.9 0-3.6-.5-4-.7-.1 0-.3-.1-.2-.4l.2-1.2c0-.2.2-.3.4-.2.3 0 1.8.5 3.3.5s2.1-.4 2.1-1.4-.7-1.3-1.8-1.5h-.5c-1.3-.3-3.6-.7-3.6-3.5s2.7-3.5 4.6-3.5 3.2.4 3.5.5c.2 0 .3.2.3.3v.2l-.2 1.2c0 .2-.1.2-.3.2-.3 0-1.6-.3-2.8-.3s-2.2.2-2.2 1.3 1.2 1.3 2.3 1.5c1.7.3 3.6.7 3.6 3.5s-2.1 3.7-4.7 3.7M369.2 205.2h-10.4c-.2 0-.4-.2-.4-.3v-15.4c0-.2.2-.3.4-.3h10.4c.2 0 .3.2.3.3v1.7c0 .2-.1.3-.3.3h-7.7v4.2h7.3c.2 0 .3.2.3.3v1.7c0 .2-.2.3-.3.3h-7.3v4.7h7.7c.2 0 .4.2.4.3v1.7c0 .2-.2.3-.4.3M383.1 205.2h-2.2c-.2 0-.3-.1-.3-.3v-7.7c0-1.3-.5-1.7-1.6-1.7s-2.4.3-2.7.4v9c0 .2-.1.3-.3.3h-2.2c-.2 0-.4-.1-.4-.3v-9.4c0-.8.4-1.1 1.6-1.4 1.1-.3 2.9-.6 4.3-.6 2.7 0 4.2.7 4.2 3.3v8.1c0 .2-.1.3-.3.3M395.9 205c-1 .3-2.2.5-3.6.5-4.3 0-5.6-1.5-5.6-5.9s1-6 4.8-6 2.7.3 3 .4l-.2-1.3v-2.9c0-.3.1-.4.4-.5l2.1-.4h.1c.2 0 .3.1.3.3v14.1c0 .6 0 1.3-1.3 1.7m-1.7-9.2c-.2 0-1.2-.2-2.1-.2-1.8 0-2.6.4-2.6 3.9s.8 4 2.7 4 1.5-.2 2-.3v-7.4zM405.8 205.5c-4.8 0-5.4-2.7-5.4-6s.6-6 5.4-6 5.4 2.7 5.4 6-.6 6-5.4 6m0-10c-2.3 0-2.4 1.4-2.4 4s0 4 2.4 4 2.4-1.4 2.4-4-.1-4-2.4-4M426.8 197.7c-1.1 1.1-2.9 1.3-4.7 1.3h-4v5.8c0 .2-.2.3-.4.3h-2.4c-.2 0-.3-.1-.3-.3v-15.4c0-.2.2-.3.4-.3h7.5c1.7 0 3.1.3 4 1.2.7.8 1.1 2 1.1 3.7s-.3 2.8-1.2 3.7m-2.7-5.7c-.6-.5-1.5-.6-2.7-.6h-3.3v5.6h3c1.4-.2 2.4-.2 3-.8.4-.4.6-1.1.6-2.2s-.2-1.7-.6-2.1M430.4 195.5c0-.8.5-1.1 1.5-1.4 1-.3 2.5-.5 3.7-.5h.8s.2.1.2.3v1.4c0 .2 0 .4-.3.4-1.3 0-2.5.1-3.1.3v8.8c0 .2-.1.3-.3.3h-2.3c-.2 0-.3-.1-.3-.3v-9.4zM444.1 205.5c-4.8 0-5.4-2.7-5.4-6s.6-6 5.4-6 5.4 2.7 5.4 6-.6 6-5.4 6m0-10c-2.3 0-2.4 1.4-2.4 4s0 4 2.4 4 2.4-1.4 2.4-4-.1-4-2.4-4M459.1 205c-.4.1-1.3.4-2.7.4-2.5 0-3.7-1-3.7-3.4v-11.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5h3.1c.2 0 .3.1.3.3v1.5c0 .2-.1.3-.3.3h-3.1v6c0 1 .4 1.3 1.5 1.3s1.3-.1 1.7-.2c.2 0 .3 0 .3.2l.3 1.2c0 .2 0 .4-.2.5M472.1 205.2h-2.2c-.2 0-.3-.1-.3-.3v-7.8c0-1.1-.4-1.6-1.6-1.6s-2.5.3-2.8.3v9c0 .2-.1.3-.3.3h-2.2c-.2 0-.4-.1-.4-.3v-15.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5l-.2 1.3c1.1-.3 2.5-.5 3.7-.5 2.5 0 3.8.7 3.8 3.1v8.2c0 .2-.1.3-.3.3M486.3 200.3c0 .2-.1.5-.5.5h-7.3c0 1 .3 1.5.9 2 .6.5 1.4.7 2.6.7s2.3-.3 3-.5h.2c.1 0 .3 0 .3.3l.3 1.1v.1c0 .2-.1.3-.3.3-.7.3-2.2.7-3.9.7-4.3 0-5.9-1.7-5.9-5.9s1.1-6 5.4-6 3.5.6 4.3 1.6c.7 1 1 2.4 1 4.2v1zm-3-3.2c-.3-1.2-.9-1.6-2.2-1.6s-2.1.4-2.3 1.5c-.2.6-.2 1.2-.2 1.9h4.9c0-.7 0-1.3-.2-1.9M496.1 205c-.4.1-1.3.4-2.7.4-2.5 0-3.7-1-3.7-3.4v-11.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5h3.1c.2 0 .3.1.3.3v1.5c0 .2-.1.3-.3.3h-3.1v6c0 1 .4 1.3 1.5 1.3s1.3-.1 1.7-.2c.2 0 .3 0 .3.2l.3 1.2c0 .2 0 .4-.2.5M502.1 205.2h-2.2c-.2 0-.3-.1-.3-.3v-10.6c0-.2.2-.3.3-.3h2.2c.2 0 .3.1.3.3v10.6c0 .2-.1.3-.3.3m-.2-12.9h-1.8c-.3 0-.5-.2-.5-.5v-2.5c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v2.5c0 .3-.2.5-.5.5M517.1 205s0 .2-.2.2H514c-.1 0-.2 0-.3-.1l-3.4-4.6h-.7v4.4c0 .2-.1.3-.3.3h-2.2c-.2 0-.3-.1-.3-.3v-15.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.4v9.3h.7l3.4-4.6c0-.1.2-.2.3-.2h2.7c.2 0 .2.2.2.3v.1l-4.1 5.2 4.3 5.5v.2M531.6 205.2h-12.1c-.2 0-.3-.2-.3-.3v-1.6c0-.4.1-.4.2-.6l8.5-11.2h-8.5c-.2 0-.3-.1-.3-.3v-1.7c0-.2.2-.3.3-.3h11.9c.2 0 .3.2.3.3v1.7c0 .2 0 .3-.2.5l-8.6 11.2h8.7c.2 0 .3.1.3.3v1.7c0 .2-.2.3-.3.3M545 200.3c0 .2-.1.5-.5.5h-7.3c0 1 .3 1.5.9 2 .6.5 1.4.7 2.6.7s2.3-.3 3-.5h.2c.1 0 .3 0 .3.3l.3 1.1v.1c0 .2-.1.3-.3.3-.7.3-2.2.7-3.9.7-4.3 0-5.9-1.7-5.9-5.9s1.1-6 5.4-6 3.5.6 4.3 1.6c.7 1 1 2.4 1 4.2v1zm-3.1-3.2c-.3-1.2-.9-1.6-2.2-1.6s-2.1.4-2.3 1.5c-.2.6-.2 1.2-.2 1.9h4.9c0-.7 0-1.3-.2-1.9M558.2 205.2H556c-.2 0-.3-.1-.3-.3v-7.7c0-1.3-.5-1.7-1.6-1.7s-2.4.3-2.7.4v9c0 .2-.1.3-.3.3h-2.2c-.2 0-.4-.1-.4-.3v-9.4c0-.8.4-1.1 1.6-1.4 1.1-.3 2.9-.6 4.3-.6 2.7 0 4.2.7 4.2 3.3v8.1c0 .2-.1.3-.3.3M568.6 205c-.4.1-1.3.4-2.7.4-2.5 0-3.7-1-3.7-3.4v-11.2c0-.3.1-.4.4-.5l2.1-.4c.3 0 .4.1.4.3v3.5h3.1c.2 0 .3.1.3.3v1.5c0 .2-.1.3-.3.3h-3.1v6c0 1 .4 1.3 1.5 1.3s1.3-.1 1.7-.2c.2 0 .3 0 .3.2l.3 1.2c0 .2 0 .4-.2.5M571.7 195.5c0-.8.5-1.1 1.5-1.4 1-.3 2.5-.5 3.7-.5h.8s.2.1.2.3v1.4c0 .2 0 .4-.3.4-1.3 0-2.5.1-3.1.3v8.8c0 .2-.1.3-.3.3h-2.3c-.2 0-.3-.1-.3-.3v-9.4zM585.8 205.5c-3.5 0-5.1-1.2-5.1-4.2v-6.9c0-.3.1-.4.4-.4l2.1-.4c.3 0 .4.1.4.3v7.6c0 1.4.5 2.1 2.2 2.1s2.2-.9 2.2-2.1v-7c0-.3.1-.4.4-.5l2.1-.4h.2c.2 0 .3.1.3.4v7.4c0 2.7-1.2 4.2-5.1 4.2M611.8 205.2h-2.2c-.2 0-.4-.1-.4-.3v-7.7c0-1.3-.5-1.7-1.7-1.7s-2.4.3-2.7.4v9c0 .2-.1.3-.3.3h-2.2c-.2 0-.3-.1-.3-.3v-7.7c0-1.3-.5-1.7-1.7-1.7s-2 .2-2.8.4v9c0 .2-.1.3-.3.3H595c-.2 0-.4-.1-.4-.3v-9.4c0-.8.4-1.1 1.6-1.4 1.1-.3 3-.6 4.4-.6s2.3.3 2.9.8c.6-.2 2.7-.8 4.4-.8 2.7 0 4.2.7 4.2 3.3v8.1c0 .2-.1.3-.3.3",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ac)",
      "mask": "url(#endoCert_svg__ab)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M168.5 68.4c-9.4 2.5-17.7 6.5-24.9 12.1-7.2 5.5-13.1 12.2-17.4 20.1-4.4 7.9-7.1 16.7-8.2 26.6-1.1 9.8-.1 20.4 2.9 31.6 3 11.2 7.4 20.8 13.2 28.7 5.8 7.9 12.5 14.2 20.1 18.7 7.6 4.5 15.9 7.3 25 8.4 9.1 1.1 18.3.3 27.9-2.3 5.7-1.5 10.8-4.1 15.5-7.7 4.7-3.6 8.8-7.7 12.4-12.4 3.6-4.7 6.6-9.7 9-15 1.4-3.1 2.5-6.1 3.5-9.1-2.2 4.8-4.9 9.3-8.1 13.5-3.3 4.2-7 8-11.3 11.2-4.2 3.2-8.9 5.6-14.1 6.9-8.6 2.3-17 3-25.2 2-8.2-.9-15.7-3.5-22.6-7.6-6.9-4.1-13-9.7-18.2-16.9-5.2-7.2-9.2-15.8-11.9-26-2.7-10.1-3.6-19.7-2.6-28.6 1-8.9 3.5-16.9 7.4-24.1 4-7.1 9.2-13.2 15.8-18.2 6.6-5 14.1-8.7 22.6-10.9 5-1.3 10-1.9 14.8-1.7-8.2-2-16.7-1.9-25.5.5",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ae)",
      "mask": "url(#endoCert_svg__ad)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__af)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ah)",
      "mask": "url(#endoCert_svg__ag)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ai)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-6.5 182.794 141.118)",
      "fill": "url(#endoCert_svg__aj)",
      "d": "M90.4 43h183.3v195.5H90.4z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__al)",
      "mask": "url(#endoCert_svg__ak)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M249.9 161.7c-.7 2.1-1.6 4.2-2.5 6.3-1 3-2.1 6-3.5 9.1-2.4 5.3-5.4 10.4-9 15-3.6 4.7-7.8 8.8-12.4 12.4-4.7 3.6-9.9 6.1-15.5 7.7-9.5 2.6-18.8 3.3-27.9 2.3-9-1-17.4-3.8-25-8.4-7.6-4.5-14.3-10.8-20.1-18.7-5.8-7.9-10.2-17.5-13.2-28.7s-4-21.7-2.9-31.6c1.1-9.9 3.8-18.7 8.2-26.6 4.4-7.9 10.2-14.6 17.4-20.1 7.2-5.5 15.6-9.6 24.9-12.1 8.8-2.4 17.3-2.5 25.5-.5 4.6.2 9.1 1.2 13.5 2.8 8.4 3.2 16.9 9.2 25.5 18 .7.7 1.3 1.4 2 2.1l8.7-9.9c-4.3-4-9.2-7.7-14.6-11.1-5.4-3.4-11.3-6-17.6-8-2-.6-4.1-1.2-6.3-1.6-4.5-1-9.1-1.6-13.9-1.8-7.1-.3-15.3.6-23 2.7-8.2 2.2-15 5.2-21.7 9-6.7 3.8-12.7 8.2-17.9 13.2-5.2 5-9.6 10.5-13.1 16.4-3.6 6-6.3 12.2-8.1 18.8-1.8 6.5-2.8 13.2-2.9 20.1 0 6.9.8 13.7 2.6 20.4 1.8 6.8 4.4 13.1 7.9 18.9 3.5 5.9 7.6 11.2 12.3 15.8 4.7 4.7 10.1 8.7 16.1 12 6 3.4 12.4 5.9 19.3 7.5 6.9 1.7 14.1 2.5 21.8 2.4 7.6 0 15.5-1.2 23.6-3.4 8.4-2.3 15.8-5.3 22-9.2 6.3-3.9 11.6-8.3 16.1-13.1 4.5-4.9 8.2-10.1 11.1-15.7 1.6-3 3-6 4.2-9.1l-11.6-3.6z",
      "fill": "#fff"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__an)",
      "opacity": ".6",
      "mask": "url(#endoCert_svg__am)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ao)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aq)",
      "mask": "url(#endoCert_svg__ap)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ar)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__as)",
      "d": "M104.5 58.5h157v157.3h-157z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__au)",
      "opacity": ".4",
      "mask": "url(#endoCert_svg__at)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__av)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ax)",
      "mask": "url(#endoCert_svg__aw)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__ay)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__az)",
      "d": "M91.5 49.8h169.8v174.9H91.5z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aB)",
      "opacity": ".4",
      "mask": "url(#endoCert_svg__aA)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aC)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aE)",
      "mask": "url(#endoCert_svg__aD)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aF)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__aG)",
      "d": "M133 75.7h111.3v120.7H133z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aI)",
      "mask": "url(#endoCert_svg__aH)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M237.1 137.4c0 2.1-.3 4.2-.9 6.3-.3 1.3-.8 2.6-1.3 3.9-.1.3-.3.7-.4 1 0 0 0 .2-.1.3-.3.6-.6 1.2-.9 1.9 0 .1-.1.3-.2.4-.1.2-.2.4-.4.6-.1.2-.2.4-.3.5-.1.2-.2.4-.4.6-.1.2-.2.4-.4.6-.1.2-.2.4-.3.5-.1.2-.3.4-.4.6-.1.2-.2.3-.3.5-.2.3-.4.5-.5.8 0 .1-.2.2-.3.3-.3.4-.6.7-.9 1.1-2.5 3.1-5.5 5.8-8.9 8.2-3.4 2.4-7.2 4.2-11.4 5.3-4.9 1.3-9.8 1.4-14.6.1-4.8-1.2-9.2-3.5-13.3-6.8-4.1-3.3-7.7-7.6-10.9-12.9-3.2-5.3-5.7-11.2-7.5-17.9 0 0-1.1-3.6-2.1-8.1-.7-3.8-.8-7.6-.4-11.1.5-3.6 1.4-6.8 2.8-9.7 1.4-2.9 3.3-5.4 5.6-7.4 1.1-1 2.4-1.9 3.6-2.6 1.3-.7 2.6-1.3 4.1-1.6 3.5-.9 6.9-1.1 10.2-.6 3.4.6 6.5 1.7 9.4 3.5 2.9 1.8 5.4 4.1 7.5 7 2.1 2.9 3.7 6.2 4.7 10l-46.8 12.4 2 8.1 70.8-19c-1.5-5.6-3.9-10.6-7.4-15.1-3.4-4.5-7.6-8.2-12.3-11-.6-.3-1.2-.7-1.8-1-.1 0-.2-.1-.3-.2-.4-.2-.9-.4-1.3-.7-.4-.2-.7-.3-1.1-.5-.2 0-.4-.2-.6-.3-.4-.2-.9-.4-1.3-.5h-.2-.1c-2.9-1.1-5.9-1.9-9.1-2.3-5.8-.9-11.9-.5-18.2 1.2-7.1 1.9-13.1 5-18.2 9.3-5.1 4.3-9 9.5-11.8 15.5-2.8 6-4.4 12.7-4.8 20.1-.4 7.4.4 15 2.5 23 1.8 6.6 4.7 12.6 8.7 17.7 4 5.2 8.8 9.3 14.2 12.5 5.4 3.2 11.3 5.3 17.7 6.3 6.4 1 12.8.7 19.3-1.1 4.9-1.3 9.6-3.6 13.9-6.8 4.3-3.2 8.1-7.1 11.3-11.5 3.2-4.4 5.7-9.3 7.6-14.6 1-2.8 1.5-5 1.7-5.8v-.3-.4c.1-.5.2-1.1.3-1.6 0-.3.1-.7.2-1 0-.4.1-.8.2-1.2v-.6-.1-.7-.8-.7-.6-.7-.5-1.1l-6.1-1z",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aJ)",
      "opacity": ".4"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aK)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aM)",
      "mask": "url(#endoCert_svg__aL)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aN)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-76.8 195.25 152.801)",
      "fill": "url(#endoCert_svg__aO)",
      "d": "M130.8 81.1h128.7v143.3H130.8z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aQ)",
      "mask": "url(#endoCert_svg__aP)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aR)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aT)",
      "mask": "url(#endoCert_svg__aS)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aU)"
    }
  }, [_c('path', {
    attrs: {
      "transform": "rotate(-9.6 194.234 136.237)",
      "fill": "url(#endoCert_svg__aV)",
      "d": "M116.8 56.1h154.8v159.8H116.8z"
    }
  })])])])]), _c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aX)",
      "opacity": ".3",
      "mask": "url(#endoCert_svg__aW)"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#endoCert_svg__aY)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "url(#endoCert_svg__aZ)",
      "d": "M147.3 82.6h96v100.6h-96z"
    }
  })])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }